<p class="heading">Publish started</p><br>
<p>Publishing currently opened and edited template, this will take a few minutes. We will notify you when the proces is finished.</p>
<br>
<button mat-flat-button color="primary" (click)="close()">Close</button>